import { render, staticRenderFns } from "./PendingReports.vue?vue&type=template&id=5471ac6c"
import script from "./PendingReports.vue?vue&type=script&lang=js"
export * from "./PendingReports.vue?vue&type=script&lang=js"
import style0 from "./PendingReports.vue?vue&type=style&index=0&id=5471ac6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports